module.exports = __webpack_public_path__ + "static/profile-ian-tetley-e713fdd8c1e4b5da68a4353604bb0637.jpg";